import { Link } from "@mui/material";
import { LinkProps } from "@mui/material/Link";
import * as React from "react";


interface IProps extends LinkProps {
    disabled?: boolean;
}

export type MprcLinkProps = IProps;

export const MprcLink: React.FC<MprcLinkProps> = (props) => {
    const { children, href, disabled = false, onClick, ...rest } = props;
    return onClick == null && href == null
        ? <>{children}</>
        : (
            <Link
                href={href || "javascrip:void(0)"}
                onClick={
                    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        if (href == null) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        if (onClick) onClick(e);
                    }
                }
                className={disabled === true ? "disabled" : undefined}
                sx={
                    disabled === true
                        ? { color: "muted.light" }
                        : undefined
                }
                {...rest}
            >
                {children}
            </Link >
        );
};
